import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { HttpClientService } from './http-client-service';

@Injectable({
  providedIn: 'root'
})
export class KvkkService {

  constructor(private http: HttpClientService) {}

  saveKvkk(body: any): Observable<any> {
    return this.http.post<any>(
      {
        controller: 'Yoklama',
        action: 'AddKVKKApproval',
      },
      body
    );
  }
}
